<template>
    <div v-if="showCategoryBox" class="faq__answerBox">
        <div class="faq__image" :class="category.image.class">
            <div class="divider--container h-full">
                <div class="divider-white--top"></div>
                <div class="faq__imageBox">
                    <span v-text="category.title" class="faq__imageLabel"></span>
                </div>
                <div class="divider-white--bottom"></div>
            </div>
        </div>
        <div class="faq__imageDesc">
            <p>
                <span v-text="category.description"></span>
                <router-link class="btn btn--secondary" :to="category.path" v-text="category.buttonLabel"></router-link>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FaqCategoryBox',
    props: {
        category: {
            required: true,
            type: Object,
        },
    },
    computed: {
        showCategoryBox: function() {
            return !this.$router.currentRoute.path.includes(this.category.path);
        },
    },
};
</script>
